const AI_SESSION_MODES = new Set([
  "areas",
  "standard",
  "challenging",
  "exam",
]);

export function hasActiveAISession({
  mode,
  aiSession,
  isPaperComplete,
}) {
  return Boolean(
    AI_SESSION_MODES.has(mode) &&
    aiSession?.session_state &&
    aiSession?.question &&
    !isPaperComplete
  );
}

export function getTutorDisplayName(
  selectedSubject
) {
  if (
    selectedSubject?.subjectCode ===
    "mathematics"
  ) {
    return "MathMaster";
  }

  if (
    selectedSubject?.paperCode ===
    "physical_sciences_p1"
  ) {
    return "PhysicsMaster";
  }

  return "ChemMaster";
}

